import styled from '@emotion/styled'
import BaseModal from 'components/modals/BaseModal'
import { Button } from 'components/theme'
import { useRedirect } from 'hooks/useRedirect'
import CompanyImage from './company-wrapper.svg'

const CompanyModal = ({ toggleModal }: { toggleModal: () => void }) => {
  const redirect = useRedirect()
  return (
    <BaseModal toggleModal={toggleModal}>
      <Root>
        <Title>About Company Listings:</Title>
        <p>
          Available on Enterprise plans* Company listings are best when you have multiple products
          or if you have one or more products that don’t match your company name. Highlight
          unlimited products by adding a product tab to your page.
        </p>
        <ImageBox>
          <Image src={CompanyImage} />
        </ImageBox>
        <SmallTitle>Features</SmallTitle>
        <FeatureList>
          <FeatureItem>Highlight your product offering (Unlimited)</FeatureItem>
          <FeatureItem>Show off your featured customers on your page</FeatureItem>
          <FeatureItem>Measure and grow traffic to your product tab</FeatureItem>
        </FeatureList>
        <ButtonWrapper>
          <GetStartedButton onClick={() => redirect('listing-stepper/networks')}>
            Get Started
          </GetStartedButton>
        </ButtonWrapper>
      </Root>
    </BaseModal>
  )
}

const ButtonWrapper = styled.div`
  text-align: center;
  padding-top: 20px;
`

const GetStartedButton = styled(Button)`
  width: 100%;
  max-width: 200px;
`

const Root = styled.div`
  padding: 24px;
  max-width: 500px;
  margin: 0 auto;
`

const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
`

const ImageBox = styled.div`
  background: #f9fafb;
  text-align: center;
  padding-top: 20px;
  margin-bottom: 20px;
`

const Image = styled.img`
  max-height: 105px;
`

const SmallTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
`

const FeatureList = styled.ul``

const FeatureItem = styled.li``

export default CompanyModal
